// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__gaLmU","title":"style__title__-agvJ","description":"style__description__-0ET6","component":"style__component__0rE02"};